<template>
    <section class="app-main">
        <div class="container is-fluid is-marginless app-content">
            <router-view class="animated" :class="transitionName"></router-view>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'app-main',
    data() {
        return {
            //
        }
    },

    computed: {
        transitionName() {
            if(this.$route.meta.hasOwnProperty('transitionName')) {
                return this.$route.meta.transitionName;
            }
            return 'fadeInLeft';
        }
    },

    components: {
        // 'app-transition': Transition,
    },

    created() {
        // console.log('transitionName: ', this.$route.meta.transitionName);

    },

}
</script>




// WEBPACK FOOTER //
// src/components/layout/AppMain.vue